import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useAuthContext } from '../../contexts/AuthContext';

export default function FeedbackModal({ show, onClose }) {
  const [message, setMessage] = useState('');
  const [contact, setContact] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const { user, linkedProfile } = useAuthContext();

  if (!show) return null;

  async function handleSubmit() {
    const text = message.trim();
    if (!text) return;
    setSubmitting(true);
    setError(null);
    try {
      await addDoc(collection(db, 'feedback'), {
        message: text.slice(0, 2000),
        contact: contact.trim().slice(0, 200) || null,
        userName: linkedProfile?.name || null,
        userId: linkedProfile?.id || null,
        authUid: user?.uid || null,
        isAnonymous: user?.isAnonymous ?? true,
        userAgent: navigator.userAgent.slice(0, 300),
        path: window.location.pathname + window.location.search,
        createdAt: new Date(),
      });
      setSubmitted(true);
      setMessage('');
      setContact('');
    } catch (e) {
      console.error('Feedback submit error:', e);
      setError('Could not send. Try again or email joeg@sanalyticsdata.com.');
    } finally {
      setSubmitting(false);
    }
  }

  function handleClose() {
    setSubmitted(false);
    setError(null);
    onClose();
  }

  return (
    <div className="blurred-app-state">
      <div className="modal-card">
        <button className="sidebar-close-btn" onClick={handleClose}>&times;</button>
        <h2>Send Feedback</h2>

        {submitted ? (
          <>
            <p>Thanks — got it. We read every one.</p>
            <button className="btn-bank" style={{ marginTop: 20 }} onClick={handleClose}>Done</button>
          </>
        ) : (
          <>
            <p style={{ marginTop: 0, marginBottom: 15 }}>
              Bug, idea, confusion — anything is useful.
            </p>
            <textarea
              className="feedback-textarea"
              placeholder="What's on your mind?"
              maxLength={2000}
              rows={5}
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
            <input
              type="text"
              className="name-input"
              style={{ marginTop: 10 }}
              placeholder="Email or name (optional)"
              maxLength={200}
              value={contact}
              onChange={e => setContact(e.target.value)}
            />
            {error && <p className="feedback-error">{error}</p>}
            <button
              className="btn-bank"
              style={{ marginTop: 20 }}
              disabled={!message.trim() || submitting}
              onClick={handleSubmit}
            >
              {submitting ? 'Sending...' : 'Send'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
